<template>
  <div class="svj-scheme__category" ref="category" v-if="option.category">
    <div class="svj-scheme__category__main" v-for="(mainCategory, index) in category" :key="index">
      <span class="svj-category__main__name">{{mainCategory.typeName}}</span>
      <ul
        class="svj-category__list"
        :class="{
            'svj-category__list--opened': openedCollection[mainCategory.typeCode],
            'svj-category__list--closed': !openedCollection[mainCategory.typeCode]
          }"
      >
        <li
          class="svj-category__item"
          :class="{
              'svj-category__item--active': selection[mainCategory.typeCode] === item.categoryId,
            }"
          v-for="item in mainCategory.subCategoryList"
          @click="chooseCategory(mainCategory.typeCode, item.categoryId)"
          :key="item.categoryId"
        >{{item.categoryName}}</li>
      </ul>
      <span
        class="svj-category__more"
        @click="openList(mainCategory.typeCode)"
        :class="{
            'svj-category__more--opened': openedCollection[mainCategory.typeCode]
          }"
      >更多</span>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import request from '@/utils/request';

const requestInstance = request();

export default {
  name: 'CategoryList',
  props: ['option', 'categoryApi'],
  data() {
    return {
      category: [],
      selection: {
        CustomTag: [],
      },
      openedCollection: {},
    };
  },
  methods: {
    openList(typeCode) {
      this.openedCollection[typeCode] = !this.openedCollection[typeCode];
    },
    calculateForMore() {
      this.$nextTick(() => {
        const categoryListEles = this.$refs.category.getElementsByClassName(
          'svj-category__list',
        );
        categoryListEles.forEach((list) => {
          const height = list.offsetHeight;
          const moreBtn = list.parentNode.getElementsByClassName(
            'svj-category__more',
          )[0];
          if (height > 46) {
            moreBtn.style.display = 'inline-block';
            list.classList.add('svj-category__list--closed');
          } else {
            moreBtn.style.display = 'none';
          }
        });
      });
    },
    chooseCategory(typeCode, categoryId) {
      this.selection[typeCode] = categoryId;

      const typeObj = {};

      Object.keys(this.selection).forEach((type) => {
        if (this.selection[type] !== 'all') {
          typeObj[type] = this.selection[type];
        }
      });
      this.$emit('change', typeObj);
    },
    initCategory() {
      Object.keys(this.selection).forEach(type => {
        this.selection[type] = 'all';
      });
      Object.keys(this.openedCollection).forEach(typeCode => {
        this.openedCollection[typeCode] = null;
      });
      this.$emit('init', {});
    },
    getCategory() {
      return requestInstance
        .post(this.categoryApi, {})
        .then((res) => {
          const category = [];
          let customIndex = 0;
          if (res.success && res.result) {
            res.result.forEach((mainCategory) => {
              const all = {
                categoryName: '全部',
                categoryId: 'all',
              };
              if (Array.isArray(mainCategory.subCategoryList)) {
                mainCategory.subCategoryList.unshift(all);
              } else {
                mainCategory.subCategoryList = [all];
              }

              // 因为存在多个CustomTag, 所以要处理一下
              if (mainCategory.typeCode === 'CustomTag') {
                mainCategory.typeCode = `CustomTag${customIndex}`;
                customIndex += 1;
              }
              // init selection
              this.$set(this.selection, mainCategory.typeCode, 'all');
              this.$set(this.openedCollection, mainCategory.typeCode, false);
              category.push(mainCategory);
            });
          }
          this.category = category;
          this.calculateForMore();
        })
        .catch((err) => {
          this.$emit('handleError', err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/mixins/mobile.scss';

.svj-scheme__category {
  width: vw(335);
  background: #ffffff;
  border-radius: vw(4);
  padding: vw(5) vw(20);
  font-size: vw(14);
  .svj-scheme__category__main {
    display: flex;
    border-bottom: vw(1) solid #eeeeee;
    &:last-child {
      border-bottom: none;
    }
    .svj-category__main__name {
      color: #333333;
      line-height: vw(46);
      margin-right: vw(28);
    }
    .svj-category__list {
      flex: 1;
      list-style: none;
      margin: 0;
      padding: vw(6) 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      overflow: hidden;
      &.svj-category__list--opened {
        height: auto !important;
      }
      &.svj-category__list--closed {
        height: vw(48);
      }
      .svj-category__item {
        cursor: pointer;
        font-weight: 400;
        color: #999999;
        padding: 0 vw(8);
        display: inline-block;
        height: vw(22);
        line-height: vw(22);
        color: #999;
        margin: vw(6) vw(4);
        border-radius: vw(4);
        &.svj-category__item--active {
          background: #178fff;
          color: #ffffff;
        }
      }
    }
    .svj-category__more {
      color: rgb(153, 153, 153);
      cursor: pointer;
      line-height: vw(46);
      &.svj-category__more--opened {
        color: rgb(23, 143, 255);
        &::after {
          transform: rotate(-135deg);
          vertical-align: vw(-2);
        }
      }
      &::after {
        display: inline-block;
        content: "";
        width: vw(7);
        height: vw(7);
        border-right: vw(1) solid rgb(153, 153, 153);
        border-bottom: vw(1) solid rgb(153, 153, 153);
        margin: 0 0 vw(3) vw(6);
        transform: rotate(45deg);
      }
    }
  }
}
</style>
